"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeepKeySDK = void 0;
const generated_1 = require("./generated");
const getKeepKeySDK = async (config) => {
    const baseConfig = new generated_1.Configuration({
        apiKey: config.serviceKey
    });
    const sdk = {
        config,
        client: new generated_1.ClientEndpointsApi(baseConfig),
        recovery: new generated_1.RecoveryEndpointsApi(baseConfig),
        developer: new generated_1.DeveloperEndpointsApi(baseConfig),
        deviceInfo: new generated_1.DeviceInfoEndpointsApi(baseConfig),
        sign: new generated_1.KeepKeySignTxEndpointsApi(baseConfig),
        wallet: new generated_1.KeepKeyWalletEndpointsApi(baseConfig),
        rawDevice: new generated_1.RawKeepKeyDeviceI0EndpointsApi(baseConfig)
    };
    const verifyAuthResp = await sdk.client.verifyAuth().catch(async (e) => {
        await sdk.client.pair({ authorization: config.serviceKey, pairBody: { ...config } });
    });
    if (verifyAuthResp && verifyAuthResp.success)
        return sdk;
    await sdk.client.pair({ authorization: config.serviceKey, pairBody: { ...config } });
    return sdk;
};
exports.getKeepKeySDK = getKeepKeySDK;
